module.exports = __webpack_public_path__ + "static/media/damaged-item.ef07e8fd.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tutorial/images/damaged-item.svg
 ** module id = 880
 ** module chunks = 0
 **/